<template>
  <div class="container">
    <!-- <heard :title="'老年多模态多媒体语料库切分标注平台--MMSE'" /> -->
    <div class="content" id="content">
      <div class="title">
        <!-- <el-button @click="goBack" style="background-color:#568156;border-color:#568156" class="backIcon" type="primary" icon="el-icon-arrow-left" circle size="mini"></el-button> -->
        <!-- <img
          src="../assets/1679386722740.jpg"
          class="backIcon"
          @click="goBack"
          alt=""
        /> -->
        <span style="color: #568156">{{ $route.query.testPageTitle  || testPageTitle}}</span>
        <el-button
          v-if="isQuery"
          type="primary"
          size="mini"
          class="userPotrait"
          @click="exportPdf"
          style="background-color: #568156; border-color: #568156"
          >导出</el-button
        >
      </div>
      <div class="examTable" id="examTable">
        <div class="examUserInfo">
          <el-form
            ref="form"
            label-width="80px"
            style="width: 100%; display: flex; flex-wrap: wrap"
          >
            <el-form-item label="姓名:" style="width: 25%">
              <el-input
                style="width: 100%"
                class="userInfo"
                placeholder="姓名"
                v-model="params.maName"
              >
                <!-- <template slot="prepend">姓名</template> -->
              </el-input>
            </el-form-item>
            <el-form-item label="性别:" style="width: 25%">
              <el-select
                placeholder="性别"
                class="userInfo"
                style="width: 100%"
                v-model="params.maSex"
              >
                <el-option
                  v-for="item in sexoptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="年龄:" style="width: 25%">
              <el-input-number
                style="width: 100%"
                placeholder="年龄"
                class="userInfo"
                v-model="params.maAge"
                :min="1"
                :max="200"
                label="年龄"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="文化程度:" style="width: 25%">
              <el-select
                placeholder="文化程度:"
                class="userInfo"
                style="width: 100%"
                v-model="params.maDegree"
              >
                <el-option
                  v-for="item in degreeOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="住址:" style="width: 43%">
              <el-input
                class="userInfo"
                style="width: 100%"
                placeholder="住址"
                v-model="params.maAddress"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="初步诊断:" style="width: 43%">
              <el-input
                class="userInfo"
                style="width: 100%"
                placeholder="初步诊断"
                v-model="params.maDiagnosis"
              >
              </el-input>
            </el-form-item>
            <template v-if="!isQuery">
              <el-button
                style="height: 40px; width: 6%; margin-left: 1%"
                @click="goBack"
                :disabled="$route.query.cmStatus ? true : false"
                >取消</el-button
              >
              <el-button
                type="primary"
                :disabled="$route.query.cmStatus ? true : false"
                @click="submit"
                v-if="type == 'edit' || type == 'add'"
                style="
                  background-color: #568156;
                  border-color: #568156;
                  height: 40px;
                  width: 6%;
                "
                >{{
                  type == 'edit' ? "更新" : "保存"
                }}</el-button
              >
            </template>
          </el-form>
        </div>
        <div class="body">
          <template v-for="(item, index) in pageList">
            <div class="body-item" v-if="item.mqType == '文字题'" :key="index">
              <div class="question">
                <div class="title">{{ item.mqCategory }}</div>
                <div class="subject">
                  <div class="subjectItem">
                    <div v-html="item.mqContent"></div>
                  </div>
                </div>
              </div>
              <div class="achievement" style="width: 200px">
                <div class="hidetitle">分数</div>
                <div class="achievementItem">
                  <el-input-number
                    class="userInfo"
                    v-model="point[index]['tpoints']"
                    :min="0"
                    size="small"
                    :max="item.mqScore *1"
                  ></el-input-number>
                </div>
              </div>
              <div class="achievement">
                <div class="hidetitle">最高分</div>
                <div class="achievementItem">{{ item.mqScore }}</div>
              </div>
            </div>
            <div class="body-item" v-else :key="index">
              <div class="question">
                <div class="title">{{ item.mqCategory }}</div>
                <div class="subject">
                  <div class="subjectItem">
                    <div v-html="item.mqContent"></div>
                  </div>
                </div>
              </div>
              <div class="achievement" style="width: 200px">
                <el-select
                  :disabled="$route.query.cmStatus ? true : false"
                  size="mini"
                  v-model="point[index]['languageValue']"
                  style="margin-bottom: 10px; width: 180px"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-link
                  size="small"
                  v-if="item.count"
                  :underline="false"
                  type="primary"
                  style="margin-bottom: 10px"
                  >录音时长：{{ item.count }}s</el-link
                >
                <el-link
                  size="small"
                  :underline="false"
                  :disabled="item.start"
                  style="margin-bottom: 10px"
                  @click="start(item)"
                  >开始录制</el-link
                >
                <el-link
                  size="small"
                  type="danger"
                  :disabled="item.end"
                  :underline="false"
                  @click="end(item)"
                  style="margin-bottom: 10px"
                  >结束录制</el-link
                >
                <el-link
                  size="small"
                  v-if="uploadMsgObj[item.id]"
                  type="success"
                  :disabled="endDisabled"
                  :underline="false"
                  @click="queryAudioFile(uploadMsgObj[item.id])"
                  >查看录音文件</el-link
                >
              </div>
              <div class="achievement">
                <div class="hidetitle">分数</div>
                <div class="achievementItem">
                  <el-input v-model="point[index]['tpoints']" />
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <!-- <div class="btnWrap" v-if="!isQuery">
          <el-button style="background-color:#568156;border-color:#568156;width: 130px" @click="submit" type="primary">{{
            type == 'add'? "保存" : "更新"
          }}</el-button>
        </div> -->
    </div>

    <el-dialog title="提示" :visible.sync="dialogTableVisible" @close="close">
      <audio ref="audio" :src="url" controls style="width: 80%"></audio>
      <el-table :data="currentFileList" border>
        <el-table-column label="录音文件">
          <template slot-scope="scoped"
            >{{ scoped.row.file }}
            <i
              class="el-icon-download"
              style="color: #409eff; cursor: pointer"
              @click="downLoad(scoped.row.file)"
            ></i
          ></template>
        </el-table-column>
        <el-table-column label="操作" width="310" align="center">
          <template slot-scope="scope">
            <el-link
              type="primary"
              style="margin-right: 10px"
              @click="play(scope.row)"
              >播放</el-link
            >
            <el-link style="margin-right: 10px" @click="stopPlay(scope.row)"
              >暂停</el-link
            >
            <el-link
              style="margin-right: 10px"
              @click="downLoadEAF(scope.row)"
              type="success"
              >EAF</el-link
            >
            <el-link
              style="margin-right: 10px"
              @click="downLoadJson(scope.row)"
              type="success"
              >JSON</el-link
            >
            <el-link
              style="margin-right: 10px"
              @click="downLoadTxt(scope.row)"
              type="success"
              >文本特征</el-link
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <foot :show="true" ref="foot" />
  </div>
</template>

<script>
import user from "../components/portrait.vue";
import heard from "../components/heard.vue";
import foot from "../components/footer.vue";
import { getCustomRecord ,saveCustomTest ,updateCustomTest ,getAnswerDetail} from "@/utils/custom";
import { uploadFile } from "@/utils/mmse"
import { mapState } from "vuex";
var recorder;
export default {
  name: "VueMmse",
  data() {
    return {
      options: [
        {
          value: "cn",
          label: "普通话",
        },
        {
          value: "cn_cantonese",
          label: "粤语",
        },
        {
          value: "cn_uyghur",
          label: "维吾尔语",
        },
        {
          value: "cn_tibetan",
          label: "藏语",
        },
      ],
      languageValue: "cn",
      sexoptions: [
        {
          label: "男",
          value: "男",
        },
        {
          label: "女",
          value: "女",
        },
      ],
      degreeOption: [
        {
          label: "其他",
          value: "其他",
        },
        {
          label: "小学",
          value: "小学",
        },
        {
          label: "初中",
          value: "初中",
        },
        {
          label: "高中",
          value: "高中",
        },
        {
          label: "本科",
          value: "本科",
        },
        {
          label: "硕士",
          value: "硕士",
        },
        {
          label: "博士",
          value: "博士",
        },
      ],
      dialogTableVisible: false,
      startDisabled: false,
      endDisabled: false,
      uploadMsg: "",
      url: "",
      point: [
        {
          tno: "1",
          tpoints: "",
        },
        {
          tno: "2",
          tpoints: "",
        },
        {
          tno: "3",
          tpoints: "",
        },
        {
          tno: "4",
          tpoints: "",
        },
        {
          tno: "5",
          tpoints: "",
        },
        {
          tno: "6",
          tpoints: "",
        },
        {
          tno: "7",
          tpoints: "",
        },
        {
          tno: "8",
          tpoints: "",
        },
        {
          tno: "9",
          tpoints: "",
        },
        {
          tno: "10",
          tpoints: "",
        },
        {
          tno: "11",
          tpoints: "",
        },
        {
          tno: "12",
          tpoints: "",
        },
        {
          tno: "13",
          tpoints: "",
        },
      ],
      uploadMsgObj: {},
      showExport: true,
      params: {
        userId: "",
        maName: "",
        maSex: "",
        maBirthday: "",
        maAge: "",
        maDegree: "",
        maTelephone: "",
        maAddress: "",
        maBedNumber: "",
        maAdmissionNumber: "",
        maDiagnosis: "",
        maAnswerInfos: "",
      },
      breadcrumbObj: {},
      count: 0,
      timer: null,
      pageList: [],
      currentFileList:[]
    };
  },
  props: {
    tableData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    testPageTitle: {
      type: String,
      default: () => {
        return "";
      },
    },
    // 量表定制页面查看
    isQuery: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    isQueryId: {
      type: String,
      default: () => {
        return '';
      },
    },
  },
  computed: {
    ...mapState(["userInfo"]),
    total() {
      let total = 0;
      this.point.forEach((item) => {
        if (!item.tpoints) {
          total += 0;
        } else {
          total += item.tpoints * 1;
        }
      });
      return total;
    },
    editId() {
      return this.$route.query.id;
    },
    cmStatus() {
      return this.$route.query.cmStatus;
    },
    type() {
      return this.$route.query.opeartType;
    },
  },
  created() {
    if (!this.userInfo.userId) {
      this.$router.push({ name: "index" });
      return;
    }
  },
  mounted() {
    if (this.editId && (this.type == 'add') || this.isQuery) {
      getCustomRecord({ mmseId: this.editId || this.isQueryId }).then((res) => {
        let point = [];
        res.rows.forEach((item,index)=>{
          item.count = 0;
          item.start = false;
          item.end = false;
          point.push({
            tno: index + 1,
            tpoints: "",
            languageValue:'cn'
          });
        })
        this.point = point
        this.pageList = res.rows;
      });
    } else if(this.type == 'query' || this.type == 'edit'){
      getAnswerDetail(this.$route.query.ID).then(res=>{
         this.params = res.data;
          res.data.questionList.forEach(item=>{
            item.count = 0;
            item.start = false;
            item.end = false;
          })
        this.pageList = JSON.parse(JSON.stringify(res.data.questionList));
        this.point = JSON.parse(res.data.maAnswerInfos);
        if(res.data.filesList && res.data.filesList.length){
          let obj = {}
          res.data.filesList.forEach(item=>{
            obj[item.questionId] = item.audioFiles.map(item1=>{
              return {
                file:item1
              }
            })
          })
          this.uploadMsgObj = obj
        }
      })
    }else{
      if (Object.keys(this.tableData).length) {
        let point = [];
        this.tableData.forEach((item, index) => {
          point.push({
            tno: index + 1,
            tpoints: "",
            languageValue:'cn'
          });
        });
        this.pageList = this.tableData;
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.breadcrumbObj = { name: from.meta.title, path: from.path };
    });
  },
  beforeDestroy() {
    this.timer && clearInterval(this.timer);
  },
  methods: {
    downLoadEAF(data) {
      let link = data.file.replace(".wav", ".eaf");
      window.open(link, "_blank");
    },
    downLoadJson(data) {
      let link = data.file.replace(".wav", ".json");
      window.open(link, "_blank");
    },
    downLoadTxt(data) {
      let link = data.file.replace(".wav", ".txt");
      window.open(link, "_blank");
    },
    queryAudioFile(list){
      this.currentFileList = list;
      this.dialogTableVisible = true
    },
    close() {
      this.stopPlay();
    },
    stopPlay() {
      this.$refs.audio.pause();
    },
    play(row) {
      this.url = row.file;
      setTimeout(() => {
        this.$refs.audio.play();
      });
    },
    start(item) {
      this.pageList.forEach(item1=>{
        item1.start = true;
        item1.end = true;
      })
      item.end  = false;
      let that = this;
      HZRecorder.get(function (rec) {
        recorder = rec;
        recorder.start();
        that.timer = setInterval(() => {
          item.count++;
        }, 1000);
      });
    },
    end(item) {
      if (!item.start) {
        this.$message.warning("请先开始录音");
        return;
      }
      this.pageList.forEach(item1=>{
        item1.start = false;
        item1.end = false;
      })
      item.count = 0
      recorder.stop();
      this.timer && clearInterval(this.timer);
      this.count = 0;
      let fd = new FormData();
      fd.append("file", recorder.getBlob());
      fd.append("language", this.languageValue);
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
      });
      uploadFile(fd).then((res) => {
        this.startDisabled = false;
        if(!this.uploadMsgObj[item.id]){
          this.$set(this.uploadMsgObj,[item.id],[{file:res.msg}])
        }else[
          this.uploadMsgObj[item.id].push({file:res.msg})
        ]
        loading.close();
      });
    },
    downLoad(file) {
      window.open(file, "_blank");
    },
    goBack() {
      this.$router.push(this.breadcrumbObj.path);
    },
    exportPdf() {
      this.showExport = false;
      setTimeout(() => {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          backgroundColor: "hsla(0,0%,100%,.9)",
        });
        let name = `${this.params.maName}_mmse.pdf`;
        let inpArray = Array.from(
          document.getElementsByClassName("el-input__inner")
        );
        inpArray.forEach((item) => {
          item.style.paddingTop = "7px";
        });
        this.getPdf(name, "content").then(() => {
          this.showExport = true;
          inpArray.forEach((item) => {
            loading.close();
            item.style.paddingTop = "";
          });
        });
      });
    },
    submit() {
      let can = true;
      this.pageList.forEach(item=>{
        if(item.end) can =  false
      })
      if (!can) {
        this.$message.warning("请先停止录音");
        return;
      }
      this.$confirm("确认提交?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.params.userId = this.userInfo.userId;
          this.params.mmseId = this.editId;
          delete this.params.currUserLevel;
          delete this.params.userLevel;
          this.params.maTotalScore = this.total;
          this.params.filesList = [];
          let ids = Object.keys(this.uploadMsgObj);
          ids.forEach(item=>{
            this.params.filesList.push({
              questionId:item,
              audioFiles:this.uploadMsgObj[item].map(item=>item.file)
            })
          })
          this.params.maAnswerInfos = JSON.stringify(this.point);
          if (this.editId && this.type == 'edit') {
            this.params.id = this.$route.query.ID;
            delete this.params.updatedTime;
            delete this.params.mmseTitle;
            delete this.params.userName;
            delete this.params.questionList;
            delete this.params.updatedBy;
            delete this.params.doctorName;
            delete this.params.createdTime;
            delete this.params.createdBy;
          }
          if(this.type == 'add'){
            this.params.authinfoId = this.$route.query.authinfoId
          }
          try {
            this.editId && this.type == 'add'
              ? await saveCustomTest(this.params)
              : await updateCustomTest(this.params) ;
            this.$router.push("/user");
          } catch (error) {
            console.log(error);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  components: {
    heard,
    foot,
    user,
  },
};
</script>
<style lang="less" scoped>
.container {
  width: 100%;
  background: #f9f9f9;
  .content {
    box-sizing: border-box;
    overflow-y: auto;
    padding: 0 60px;
    .title {
      margin: 30px 0;
      color: black;
      font-weight: bold;
      font-size: 20px;
      text-align: center;
      position: relative;
      .backIcon {
        cursor: pointer;
        position: absolute;
        left: 0;
        top: 0;
      }
      .userPotrait {
        position: absolute;
        right: 0px;
        top: 0;
      }
    }
    .examTable {
      border: 1px solid black;
      width: 100%;
      box-sizing: border-box;
      margin-bottom: 70px;
      .examUserInfo {
        padding: 15px;
        display: flex;
        flex-wrap: wrap;
        padding-bottom: 0;
        .maSex {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .userInfo {
          text-align: left;
          margin-right: 15px;
          width: 18%;
          margin-bottom: 15px;
        }
      }
      .body {
        border-top: 1px solid black;
        .body-item {
          display: flex;
          // height: 100%;
          min-height: 200px;
          border-bottom: 1px solid black;
          &:last-child {
            border: 0;
          }
          .question {
            // flex: 1;
            width: 74%;
            display: flex;
            padding: 15px;
            visibility: visible;
            .title {
              width: 110px;
            }
            .left {
              flex: 1;
              width: 100%;
              height: 100%;
              img {
                width: auto;
                height: 100%;
              }
            }
            .right {
              flex: 1;
              display: flex;
              align-items: flex-start;
              justify-content: center;
              flex-direction: column;
            }
            .title {
              text-align: left;
              font-size: 18px;
              color: black;
              font-weight: bold;
              margin-top: 0;
            }
            .subject {
              .subjectItem {
                margin-bottom: 12px;
              }
            }
          }
        }
        .achievement {
          width: 60px;
          padding: 15px;
          flex-shrink: 0;
          border-left: 1px solid black;
          display: flex;
          justify-content: center;
          flex-direction: column;
          .hidetitle {
            text-align: center;
            margin: 10px 0;
            font-size: 18px;
            color: black;
            font-weight: bold;
          }
          .achievementItem {
            margin-bottom: 12px;
            text-align: center;
            height: 40px;
            line-height: 40px;
          }
        }
      }
    }
    .total {
      text-align: right;
      margin-bottom: 60px;
      font-size: 22px;
    }
    .btnWrap {
      display: flex;
      justify-content: center;
    }
  }
}
</style>
